// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.11_webpack@5.106.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_@rspack+core@1.7.11_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-view {
  display: none;
}
.desktop-view {
  display: block;
}
/* Mobile*/
@media (max-width: 768px) {
  .mobile-view {
    display: block;
  }
  .desktop-view {
    display: none;
  }
}
.instant-play-card {
  display: flex;
  align-items: stretch;
  align-self: stretch;
  background-color: #ffffff;
  border-radius: 24px;
  box-shadow: 0px 8px 32px 0px #34383f14;
  margin-bottom: 32px;
}
.instant-play-card .instant-play-image {
  width: 200px;
  height: auto;
  align-self: stretch;
  overflow: hidden;
  background-color: white;
  border-radius: 24px 0 0 24px;
}
.instant-play-card .instant-play-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.instant-play-card .instant-play-content {
  display: flex;
  padding: 24px;
  align-items: center;
  gap: 24px;
  flex: 1 0 0;
  align-self: stretch;
}
.instant-play-card .instant-play-content .instant-play-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  flex: 1 0 0;
}
.instant-play-card .instant-play-content .instant-play-info .instant-play-infoData {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
}
.instant-play-card .instant-play-content .instant-play-info .instant-play-infoData .title {
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}
.instant-play-card .instant-play-content .instant-play-info .instant-play-infoData .description {
  color: #59606d;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}
.instant-play-card .instant-play-content .instant-play-info .instant-play-infoData .description .description-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}
.instant-play-card .instant-play-content .instant-play-button {
  flex-shrink: 0;
  white-space: nowrap;
  margin-left: 12px;
}
.instant-play-card .instant-play-content .instant-play-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
